import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { supportServiceCategoryApiClient } from '@src/api/tenant/supportService/supportServiceCategoryApiClient';
import { SupportServiceCategory } from '@src/api/types/supportServiceCategory';
import EditCategoryModal from '@src/components/EditCategoryModal';
import SortableCategoryTable from '@src/components/sortableCategory/SortableCategoryTable';
import SpinnerOverlay from '@src/components/SpinnerOverlay';
import Title from '@src/ui/elements/typography/Title';
import logger from '@src/utils/logger';
import { useCallback, useEffect, useState } from 'react';

const SupportServiceCategoryListForm: React.FC = () => {
  const [categories, setCategories] = useState<SupportServiceCategory[]>([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<Partial<SupportServiceCategory> | null>(
    null,
  );
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState<boolean>(false);

  const fetchCategories = async () => {
    setLoading(true);
    const response = await supportServiceCategoryApiClient.index();
    handleApiResponse(
      response,
      (data) => {
        setCategories(data);
      },
      (error) => {
        console.error('カテゴリを取得できませんでした:', error);
        logger.error('カテゴリを取得できませんでした:', error);
      },
    );
    setLoading(false);
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleEditClick = (category: SupportServiceCategory) => {
    setSelectedCategory(category);
    setIsEditModalOpen(true);
  };

  const handleOrderChange = async (updatedItems: SupportServiceCategory[]) => {
    const mappedUpdatedItems = {
      orders: updatedItems.map((item) => {
        return {
          id: item.id,
          order: item.order,
        };
      }),
    };

    const response = await supportServiceCategoryApiClient.updateOrder(mappedUpdatedItems);
    handleApiResponse(
      response,
      () => {
        setCategories(updatedItems);
      },
      (error) => {
        console.error('カテゴリの順番を更新できませんでした:', error);
        logger.error('カテゴリの順番を更新できませんでした:', error);
      },
    );
  };

  const SortableCategoryTableCallback = useCallback(() => {
    return (
      <SortableCategoryTable
        data={categories}
        handleEditClick={handleEditClick}
        onOrderChange={handleOrderChange}
      />
    );
  }, [categories]);

  const handleSave = async () => {
    if (selectedCategory && selectedCategory.id !== undefined) {
      const response = await supportServiceCategoryApiClient.update(
        selectedCategory.id,
        selectedCategory as SupportServiceCategory,
      );

      handleApiResponse(
        response,
        () => {
          fetchCategories();
          handleCancel();
        },
        (error) => {
          setErrors(error);
          console.error('カテゴリを更新できませんでした:', error);
          logger.error('カテゴリを更新できませんでした:', error);
        },
      );
    }
  };

  const handleCancel = () => {
    setIsEditModalOpen(false);
    setErrors({});
  };

  return (
    <div className='py-2'>
      {loading && <SpinnerOverlay loading={loading} />}
      <Title>カテゴリ一覧</Title>
      <div className='mt-4'>
        <SortableCategoryTableCallback />
      </div>
      <EditCategoryModal
        isOpen={isEditModalOpen}
        category={selectedCategory}
        onCategoryChange={setSelectedCategory}
        onSave={handleSave}
        onCancel={handleCancel}
        errors={errors}
      />
    </div>
  );
};

export default SupportServiceCategoryListForm;
